import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'CEO, TechStart Inc.',
    content: 'PrTechZone delivered an exceptional mobile app that exceeded our expectations. His attention to detail and technical expertise is unmatched.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Founder, HealthPlus',
    content: 'Working with PrTechZone was a game-changer. He transformed our vision into a beautiful, functional web platform that our users love.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Product Manager, FinanceApp',
    content: 'PrTechZone is professional, responsive, and incredibly skilled. He delivered our project on time and within budget.',
    rating: 5,
  },
  {
    id: 4,
    name: 'David Thompson',
    role: 'Director, EduTech Solutions',
    content: 'PrTechZone built our school management app with precision and care. The app has been a huge success with our users.',
    rating: 5,
  },
];

const TestimonialCard = ({ testimonial, isActive }) => {
  return (
    <motion.div
      className={`testimonial-card ${isActive ? 'active' : ''}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: isActive ? 1 : 0.5, scale: isActive ? 1 : 0.9 }}
      transition={{ duration: 0.5 }}
    >
      <div className="testimonial-rating">
        {[...Array(testimonial.rating)].map((_, i) => (
          <span key={i} className="star">⭐</span>
        ))}
      </div>
      <p className="testimonial-content">"{testimonial.content}"</p>
      <div className="testimonial-author">
        <div className="author-info">
          <h4 className="author-name">{testimonial.name}</h4>
          <p className="author-role">{testimonial.role}</p>
        </div>
      </div>
    </motion.div>
  );
};

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="testimonials" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">What My Clients Say</h2>
          <p className="section-subtitle">
            Trusted by businesses for delivering exceptional results
          </p>
        </motion.div>

        <div className="testimonials-carousel">
          <div className="testimonials-track">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard
                key={testimonial.id}
                testimonial={testimonial}
                isActive={index === currentIndex}
              />
            ))}
          </div>

          <div className="carousel-indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

